import RecordVideoContainer from './record-video.container'

export default RecordVideoContainer
